/**
 * Initialize the 'upsell banner ad' state.
 *
 * @type {Object}
 */
const INITIAL_STATE = {};

export default INITIAL_STATE;
